<template>
  <div>
    <!-- <el-button @click="exportx">导出</el-button>
    <el-button @click="upload">上传</el-button>
    <p>{{ url }}</p>
    <p>{{ num }}/{{ total }}</p>
    <el-upload class="upload-demo" :action="uploadUrl" :on-success="success">
      <el-button size="small" type="primary">点击上传</el-button>
      <div slot="tip" class="el-upload__tip">
        只能上传jpg/png文件，且不超过500kb
      </div>
    </el-upload> -->
    <div id="pic" v-if="render === ''">
      <div id="header">
        <div class="meng"></div>
        <img :src="img" crossorigin="anonymous" class="background" />
        <span>{{ subjectE }}</span>
        <img src="../assets/1v1.png" />
      </div>
      <div id="tail">
        <img src="../assets/yinying.png" />
        <div class="box">
          <div class="jiao1" />
          <div class="jiao2" />
          <div class="jiao3" />
          <div class="jiao4" />
          <div class="textbox">
            <p class="title">
              <span style="color:#d5ad85">{{ subject }}</span
              >-{{ title }}
            </p>
            <div class="line" style="margin: 40px 0 ;"></div>
            <div>
              <p style="display: inline-block;vertical-align: top;">
                涉及方向：
              </p>
              <p class="ide">
                {{ direction }}
              </p>
            </div>
            <p style="display: inline-block;vertical-align: top;">
              {{ '导师身份：' }}
            </p>
            <div class="ide">
              <p v-for="item in teacher" :key="item">{{ item }}</p>
            </div>

            <div class="bottom">
              <div class="b1">
                <img src="../assets/zi.png" />
              </div>
              <div class="b3">
                <div id="qrcode" />
                <p>识别二维码了解详情</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <img :src="render" v-else style="width:100%" />
  </div>
</template>

<script>
import subjects from './subject.json'
import QRCode from 'qrcodejs2'
import axios from '../axios'
import html2canvas from 'html2canvas'
export default {
  name: 'page2',
  data () {
    return {
      uploadUrl: `${axios.defaults.baseURL}/upload/`,
      subject: '生物信息学',
      description: '一封专属导师推荐信 一封完整的科研报告 一次完整的科研经历',
      title: '公共舆情分析与性别社会对立研究',
      subjectE: 'ECONOMICS',
      direction: '经济学 | 统计学 | 公共管理',
      teacher: [
        '香港大学浸会大学博士',
        '中国人民大学博士',
        'EI/CPCI国际学术会议委员会成员'
      ],
      key: '',
      qrcode: '',
      url: '',
      OSS: process.env.VUE_APP_OSS,
      img: '',
      uuid: '',
      total: 0,
      num: 0,
      render: ''
    }
  },
  mounted () {
    this.uuid = this.$route.query.uuid
    axios
      .get('previews/get_acpage', {
        params: {
          uuid: this.uuid
        }
      })
      .then(res => {
        let data = res.data
        this.title = data.title
        this.img = this.$route.query.img
        this.teacher = []
        this.teacher.push(data.teacher[0])
        this.teacher.push('EI/CPCI国际学术会议委员会成员')
        this.direction = data.direction
        this.subject = data.subject
        this.set()
        this.exportx()
      })
  },
  methods: {
    set () {
      this.subjectE = subjects[this.subject]
      let s = this.subjectE
      document
        .querySelector('#header span')
        .setAttribute('style', `font-size:120px`)
      if (s.length > 7) {
        document
          .querySelector('#header span')
          .setAttribute('style', `font-size:100px`)
      }
      if (s.length > 9) {
        document
          .querySelector('#header span')
          .setAttribute('style', `font-size:90px`)
      }
      if (s.length > 11) {
        document
          .querySelector('#header span')
          .setAttribute('style', `font-size:80px`)
      }
      if (s.length > 13) {
        document
          .querySelector('#header span')
          .setAttribute('style', `font-size:75px`)
      }
      if (s.length > 20) {
        document
          .querySelector('#header span')
          .setAttribute('style', `font-size:60px;line-height: 80px;`)
      }
      let qrcode = `https://${window.location.host}/acpage/` + this.uuid
      document.getElementById('qrcode').innerHTML = ''
      // eslint-disable-next-line no-new
      new QRCode('qrcode', {
        text: qrcode,
        width: 210, // 图像宽度
        height: 210, // 图像高度
        colorDark: '#000000', // 前景色
        colorLight: '#ffffff', // 背景色
        typeNumber: 4,
        correctLevel: QRCode.CorrectLevel.H
      })
    },
    exportx () {
      this.$nextTick(() => {
        document.body.style.width = '2024px'
        html2canvas(document.querySelector('#pic'), {
          useCORS: true,
          scrollY: 0,
          height: 2425
        }).then(canvas => {
          // let a = document.createElement('a')
          // let url = canvas.toDataURL('image/png')
          // a.href = url
          // a.setAttribute('target', '_blank')
          // a.download = `${this.title}.png`
          // a.click()
          // this.num++
          document.body.style.width = 'unset'
          this.render = canvas.toDataURL('image/jpeg', 0.9)
          let arr = this.render.split(',')
          let mime = arr[0].match(/:(.*?);/)
          // eslint-disable-next-line no-undef
          let bstr = atob(arr[1])
          let n = bstr.length
          let u8arr = new Uint8Array(n)
          while (n--) {
            u8arr[n] = bstr.charCodeAt(n)
          }
          // eslint-disable-next-line no-undef
          let param = new FormData()
          param.append(
            'file',
            // eslint-disable-next-line no-undef
            new File([u8arr], `${this.title}.png`, { type: mime })
          )
          param.append('uuid', this.uuid)
          param.append('type', 'acpage')
          axios
            .post('previews/upload', param, {
              headers: {
                'Content-Type': 'multipart/form-data'
              }
            })
            .then(res => {
              window.parent.postMessage(`acpage?=${res.data.url}`, '*')
            })
            .catch(() => {
              window.parent.postMessage('error', '*')
            })
        })
      })
    },
    upload () {
      axios
        .get('previews/add_acpage', {
          params: {
            key: this.key
          }
        })
        .then(res => {
          this.url = res.data.url
          let pages = res.data.pages
          let i = 0
          this.total = pages.length
          pages.forEach(e => {
            i++
            setTimeout(() => {
              this.direction = e.direction
              this.teacher = []
              this.teacher.push(e.teacher[0])
              this.teacher.push('EI/CPCI国际学术会议委员会成员')
              this.title = e.title
              this.subject = e.subject
              let img = this.title.replace('/', '_')
              this.img = `${this.OSS}/pages/${img}.png`
              this.uuid = e.uuid
              this.set()
              setTimeout(() => {
                this.exportx()
              }, 1000)
            }, i * 5000)
          })
        })
    },
    success (res) {
      this.key = res.key
    }
  }
}
</script>
<style lang="scss" scoped>
* {
  font-family: PFBD;
}
#pic {
  font-weight: 600;
  width: 1125px;
}
#header {
  height: 1125px;
  background-position: bottom;
  position: relative;
  .background {
    width: 1125px;
    height: 1500px;
    top: 0;
    z-index: -1;
  }
  span {
    color: #fff;
    font-size: 105px;
    position: absolute;
    left: 50px;
    bottom: 860px;
    font-weight: bolder;
    line-height: 100px;
    font-family: LemonMilkbold;
    width: 700px;
  }
  img {
    position: absolute;
    bottom: 0;
    right: 0;
    height: 1125px;
  }
}
#tail {
  padding: 85px 70px 95px;
  position: relative;
  > img {
    position: absolute;
    top: -44px;
    left: -45px;
  }
}
.box {
  padding: 60px;
  height: 1000px;
  position: relative;
}
.jiao1 {
  border-left: 20px solid #000;
  border-top: 20px solid #000;
  width: 40px;
  height: 40px;
  left: 0;
  top: 0;
  position: absolute;
}
.jiao2 {
  border-right: 20px solid #000;
  border-top: 20px solid #000;
  width: 40px;
  height: 40px;
  right: 0;
  top: 0;
  position: absolute;
}
.jiao3 {
  border-left: 20px solid #000;
  border-bottom: 20px solid #000;
  width: 40px;
  height: 40px;
  left: 0;
  bottom: 0;
  position: absolute;
}
.jiao4 {
  border-right: 20px solid #000;
  border-bottom: 20px solid #000;
  width: 40px;
  height: 40px;
  right: 0;
  bottom: 0;
  position: absolute;
}
.textbox {
  p {
    font-size: 43px;
    line-height: 70px;
  }
  .title {
    font-size: 60px;
    line-height: 80px;
  }
}
p {
  font-size: 36px;
  font-weight: 500;
  line-height: 2;
}
.line {
  width: 100px;
  border-top: 5px solid #000;
}
b {
  font-family: LemonMilkbold;
  letter-spacing: 8px;
}
.bottom {
  position: absolute;
  bottom: 60px;
  width: 865px;
  height: 350px;
  border-top: 5px solid #000;
  .b1 {
    position: absolute;
    top: 95px;
    img {
      width: 600px;
    }
  }
  .b2 {
    position: absolute;
    top: 110px;
    left: 280px;
    line-height: 77px;
    font-weight: bolder;
  }
  .b3 {
    position: absolute;
    right: 0;
    bottom: 0;
    width: 210px;
    height: 260px;
    #qrcode {
      position: absolute;
      width: 210px;
      height: 210px;
      margin: auto;
    }
    p {
      position: absolute;
      bottom: 0;
      font-size: 22px;
      line-height: 30px;
    }
  }
}
.ide {
  display: inline-block;
  width: 645px;
}
.meng {
  height: 1125px;
  width: 1125px;
  position: absolute;
  top: 0px;
  z-index: 0;
  background: rgba(#040000, 0.6);
}
</style>
